import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createBlock as _createBlock, createElementVNode as _createElementVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-240b2723")
const _hoisted_1 = { class: "p-d-flex p-ai-center" }
const _hoisted_2 = { class: "p-col-7 p-d-flex" }
const _hoisted_3 = {
  key: 0,
  class: "p-text-bold p-col-4"
}
const _hoisted_4 = {
  key: 1,
  class: "p-col-3"
}
const _hoisted_5 = {
  key: 2,
  class: "p-col-3"
}
const _hoisted_6 = { class: "p-col-5 p-d-flex p-ai-center" }
const _hoisted_7 = { class: "p-input-icon-left p-mt-3 p-mr-5" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Chip = _resolveComponent("Chip")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_CustomFilterSelector = _resolveComponent("CustomFilterSelector")!

  return (_openBlock(), _createElementBlock("article", _hoisted_1, [
    _createElementVNode("section", _hoisted_2, [
      (_ctx.tableResultsText)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.tableResultsText) + ": " + _toDisplayString(_ctx.resultsNumber), 1))
        : _createCommentVNode("", true),
      (_ctx.selectedCustomFilter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_Chip, {
              removable: "",
              onRemove: _ctx.emitRemoveActiveFilter,
              class: "custom-chip"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.selectedCustomFilter.name), 1)
              ]),
              _: 1
            }, 8, ["onRemove"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.selectedCustomView)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_Chip, {
              removable: "",
              onRemove: _ctx.emitRemoveActiveView,
              class: "custom-chip"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.selectedCustomView.name), 1)
              ]),
              _: 1
            }, 8, ["onRemove"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.isFiltered)
        ? (_openBlock(), _createBlock(_component_Button, {
            key: 3,
            label: "Guardar filtros",
            class: "p-button-text button-underlined p-col-2",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.emitToggleCreateFilter()), ["prevent"]))
          }))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("section", _hoisted_6, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createVNode(_component_InputText, {
            modelValue: _ctx.searchTxtRef,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchTxtRef = $event)),
            placeholder: "Buscar",
            disabled: _ctx.isLoading
          }, null, 8, ["modelValue", "disabled"])
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_CustomFilterSelector, {
          allColumns: _ctx.allColumns,
          allFilters: _ctx.allCustomFilters,
          allViews: _ctx.allCustomViews,
          selectedColumns: _ctx.selectedColumns,
          "onUpdate:selectedColumns": _ctx.emitSelectColumns,
          onSelectFilter: _ctx.emitSelectFilter,
          onDeleteFilter: _ctx.emitDeleteFilter,
          onToogleCreateFilter: _ctx.emitToggleCreateFilter
        }, null, 8, ["allColumns", "allFilters", "allViews", "selectedColumns", "onUpdate:selectedColumns", "onSelectFilter", "onDeleteFilter", "onToogleCreateFilter"])
      ])
    ])
  ]))
}